<template>
  <div data-v-f531b812="" class="app app-ti_green">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">合营计划</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pahsn">
      <img data-v-56fcd294="" src="/static/image/__al__title01.7a3975958589d48b22c30b3b976a95fc.png" style="display: block; width: 80%; margin: 0 auto; padding-top: 30px" />
      <img data-v-56fcd294="" src="/static/image/__al__person01.8b896040f87c2dfffa7e8de68ed19c42.png" style="display: block; width: 100%; margin: 0 auto" />
      <div @click="$parent.openKefu" class="zixun">
        <img data-v-56fcd294="" src="/static/image/16044962635685155.png" />
        <div class="cnets">
          <div class="tos">合营部</div>
          <div class="bos">立即咨询</div>
        </div>
        <div class="zusnb">咨询</div>
      </div>
      <div class="bsd">
        <div v-if="isAgent" class="agent-dashboard">
          <div class="panel-title">我的代理概况</div>
          <div class="card-grid">
            <div class="info-card">
              <div class="label">当前月份</div>
              <div class="value">{{ overview.month || '--' }}</div>
            </div>
            <div class="info-card">
              <div class="label">团队有效流水</div>
              <div class="value">{{ money(overview.team_valid_bet) }}</div>
            </div>
            <div class="info-card">
              <div class="label">团队本月输赢</div>
              <div class="value">{{ money(overview.team_win_loss) }}</div>
            </div>
            <div class="info-card">
              <div class="label">返佣金额</div>
              <div class="value">{{ money(overview.commission_amount) }}</div>
            </div>
            <div class="info-card">
              <div class="label">合营分成</div>
              <div class="value">{{ money(overview.share_amount) }}</div>
            </div>
            <div class="info-card">
              <div class="label">团队代理/会员</div>
              <div class="value">{{ overview.team_agent_count || 0 }}/{{ overview.team_member_count || 0 }}</div>
            </div>
          </div>
          <van-button style="background:#cf866b;color:#fff" @click="openAgentCenter" block>进入代理后台</van-button>
        </div>

        <div v-else>
          <div class="panel-title">代理规则</div>
          <div class="rule-box">
            <div class="rule-line">支持层级：1-{{ rules.max_level || 6 }}级代理</div>
            <div class="rule-line">合营分成：{{ percent(rules.share_ratio) }}</div>
            <div class="rule-line">输赢冲抵：{{ rules.loss_carry_forward ? '开启' : '关闭' }}</div>
            <div class="rule-line" v-for="item in rules.levels" :key="item.level">
              {{ item.level }}级代理：有效流水满 {{ money(item.min_valid_bet) }}，返佣 {{ percent(item.commission_rate) }}
            </div>
          </div>
          <van-form>
            <van-field label="用户名" v-model="$store.state.userInfo.username" disabled />
            <van-field label="真实姓名" v-model="$store.state.userInfo.realname" disabled />
            <van-field label="联系方式" v-model="info.mobile" placeholder="请输入您的联系方式" />
            <van-field label="申请理由" v-model="info.apply_info" placeholder="请输入申请说明" />
          </van-form>
          <van-button style="background:#cf866b;color:#fff" @click="shenqing" block>加入我们</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'applyagent',
  data() {
    return {
      info: {},
      rules: {
        levels: [],
      },
      overview: {},
    };
  },
  created() {
    this.getRules();
    if (this.isAgent) {
      this.getOverview();
    }
  },
  computed: {
    isAgent() {
      return Number(this.$store.state.userInfo.isagent) === 1;
    },
  },
  methods: {
    money(value) {
      return Number(value || 0).toFixed(2);
    },
    percent(value) {
      return `${Number(value || 0).toFixed(2)}%`;
    },
    getRules() {
      this.$apiFun.post('/api/agent/rules', {}).then(res => {
        if (res.code === 200 && res.data) {
          this.rules = Object.assign({ levels: [] }, res.data);
        }
      });
    },
    getOverview() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/agent/overview', {}).then(res => {
        this.$parent.hideLoading();
        if (res.code === 200 && res.data) {
          this.overview = res.data;
          return;
        }
        this.$parent.showTost(0, res.message || '获取代理数据失败');
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    openAgentCenter() {
      this.$router.push('/gamePage?dailiD=1');
    },
    shenqing() {
      let that = this;
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      if (!info.apply_info) {
        that.$parent.showTost(0, '请输入申请理由');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.$parent.showTost(1, res.message);
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pahsn {
  background: url(/static/image/__al__background.2e29d452d69738493237414076a048d3.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 40px;
  min-height: 100vh;
  width: 100%;
}
.zixun {
  width: 88%;
  margin: 0 auto;
  background: #fdfdfd;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
  position: relative;
  margin-top: -96px;
  opacity: 0.9;
  img {
    width: 30px;
    margin-right: 10px;
  }
  .cnets {
    flex: 1;
    border-left: 1px solid #ccc;
    padding-left: 10px;

    .tos {
      font-size: 12px;
      color: #999;
    }
    .bos {
      font-size: 14px;
      color: #1e1e1e;
    }
  }
  .zusnb {
    width: 60px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #cf866b;
    border-radius: 4px;
  }
}

.bsd {
  width: 90%;
  margin: 0 auto;
  background: #fdfdfd;
  border-radius: 10px;
  padding: 20px 10px;
  margin-top: 10px;
}
.panel-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}
.rule-box {
  background: #faf6f3;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}
.rule-line {
  font-size: 12px;
  line-height: 20px;
  color: #6a554d;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}
.info-card {
  background: #faf6f3;
  border-radius: 8px;
  padding: 12px;
}
.label {
  font-size: 12px;
  color: #999;
}
.value {
  font-size: 16px;
  font-weight: 600;
  color: #cf866b;
  margin-top: 6px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/applyagent.vue